import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import { dataImg } from "./dataImg";
import formatIndianNumber from "./formatIndianNumber";
import convertS3ToCloudFront from "./convertS3ToCloudFront";
let apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

async function createBDFExcelChanges(
  bdfData,
  inventories,
  proposalInvs,
  downloadBDF,
  log,
  suffixInventories,
  isSubBDF
) {
  // console.log("suffixInventories are: ", suffixInventories);

  console.log("bdfData are: ", bdfData);

  const formatCellValue = (value) =>
    value == null || value === undefined ? "" : value;

  const normalizeForCompare = (value) =>
    value == null || value === "" ? null : value;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("BDF Data");
  // worksheet.getColumn(11).width = 100;
  const imageId = workbook.addImage({
    base64: dataImg, // Your base64 encoded image data here
    extension: "png",
  });
  worksheet.addImage(imageId, "A1:A3");
  worksheet.mergeCells("1:3");

  // Merge cells for the title
  worksheet.mergeCells("C1:N1");
  worksheet.getCell("C1").value = "Yellow Spot OOH";
  worksheet.getCell("C1").font = { size: 30, bold: true };
  worksheet.getCell("C1").alignment = {
    vertical: "middle",
    horizontal: "center",
  };

  worksheet.mergeCells("C2:N2");
  worksheet.getCell("C2").value = "Business Detail Form";
  worksheet.getCell("C2").font = { size: 25, bold: true };
  worksheet.getCell("C2").alignment = {
    vertical: "middle",
    horizontal: "center",
  };

  for (let row = 1; row <= 3; row++) {
    worksheet.getCell(`N${row}`).border = {
      right: { style: "thin" },
    };
  }

  for (let col = 1; col <= 13; col++) {
    worksheet.getCell(1, col).border = {
      top: { style: "thin" },
    };
  }

  let row;
  if ((row = 1)) {
    worksheet.getCell(`N${row}`).border = {
      right: { style: "thin" },
      top: { style: "thin" },
    };
  }

  for (let col = 1; col <= 13; col++) {
    worksheet.getCell(3, col).border = {
      bottom: { style: "thin" },
    };
  }

  worksheet.getCell(`N${3}`).border = {
    right: { style: "thin" },
  };

  for (let row = 1; row <= 4; row++) {
    worksheet.getCell(`A${row}`).border = {
      left: { style: "thin" },
    };
  }

  worksheet.getCell("A1").border = {
    top: { style: "thin" },
  };

  worksheet.getRow(1).height = 40;
  worksheet.getRow(2).height = 40;
  worksheet.getRow(3).height = 20;

  worksheet.getCell(1, 2).border = {
    right: { style: "thin" },
    top: { style: "thin" },
  };
  worksheet.getCell(2, 2).border = {
    right: { style: "thin" },
  };
  worksheet.getCell(3, 2).border = {
    right: { style: "thin" },
  };
  worksheet.getCell(4, 2).border = {
    right: { style: "thin" },
  };

  const bdfHeaders1 = [
    "Serial / BDF No",
    "BDF Date",
    "Sales Person Name",
    "Sales Person Base Location",
    "Media Planner Name",
    "Client Category",
    "Lead From",
    "R.O. / Contract Note No.",
  ];

  console.log("bdfData?.gstOrPan are: ", bdfData?.gstOrPan);

  // Use gstOrPan to decide header and value: "GST Number" → Client GST, "PAN Number" → Client PAN Number
  const isGstMode = bdfData?.gstOrPan === "GST Number";
  const gstValue =
    proposalInvs?.GST ||
    bdfData?.gstNumber ||
    bdfData?.parentCompanyId?.gstNumber ||
    bdfData?.brandId?.partyCompany?.gstNumber;
  const panValue =
    bdfData?.panNumber ||
    bdfData?.parentCompanyId?.panNumber ||
    bdfData?.brandId?.partyCompany?.panNumber;
  const gstHeader = isGstMode ? "Client GST" : "Client PAN Number";
  const gstOrPanDisplayValue = isGstMode ? gstValue : panValue;

  const bdfHeaders2 = [
    "Parent Company Name",
    gstHeader,
    "Brand Name",
    "Campaign Name",
    "Billing Party Name",
    "Billing Address",
    "Brand Segment",
    "Contact Person",
  ];

  const bdfHeaders3 = [
    "Contact Number",
    "Contact Person Email ID",
    "Mode of Payment",
    "Credit Period",
    "Campaign Duration",
    "Remark(If any)",
  ];

  const toUpperCase = (str) => {
    if (!str) return str;
    return str.toString().toUpperCase();
  };

  const generateHighlightedValues = (bdfData, log) => {
    const compareValues = (bdfValue, logValue) => {
      if (Object.keys(log).length === 0) {
        return false; // No highlight if log is empty
      }

      if (typeof bdfValue === "object" && bdfValue !== null) {
        // Recursively compare nested objects
        return Object.keys(bdfValue).reduce((result, key) => {
          result[key] = compareValues(bdfValue[key], logValue?.[key]);
          return result;
        }, {});
      }
      // Highlight if value is different or doesn't exist in log
      return normalizeForCompare(bdfValue) !== normalizeForCompare(logValue);
    };

    return {
      bdfValues1: [
        {
          value: bdfData.stamp,
          highlight: compareValues(bdfData.stamp, log?.stamp),
        },
        {
          value:
            bdfData.bdfDate ||
            moment(bdfData?.createdAt).format("DD-MM-YYYY"),
          highlight: compareValues(
            moment(bdfData?.createdAt).format("DD-MM-YYYY"),
            moment(log?.createdAt).format("DD-MM-YYYY")
          ),
        },
        {
          value: bdfData.salesPerson,
          highlight: compareValues(bdfData.salesPerson, log?.salesPerson),
        },
        {
          value: bdfData.salesPersonBaseLocation,
          highlight: compareValues(
            bdfData.salesPersonBaseLocation,
            log?.salesPersonBaseLocation
          ),
        },
        {
          value: bdfData.mediaPlannerName,
          highlight: compareValues(
            bdfData.mediaPlannerName,
            log?.mediaPlannerName
          ),
        },
        {
          value: bdfData.clientCategory,
          highlight: compareValues(bdfData.clientCategory, log?.clientCategory),
        },
        {
          value: bdfData.leadFrom,
          highlight: compareValues(bdfData.leadFrom, log?.leadFrom),
        },
        {
          value: bdfData.ro,
          highlight: log?.ro ? compareValues(bdfData?.ro, log?.ro) : false,
        },
      ],
      bdfValues2: [
        {
          value: toUpperCase(bdfData?.parentCompanyName),
          highlight: compareValues(
            bdfData.parentCompanyName,
            log?.parentCompanyName
          ),
        },
        {
          value: gstOrPanDisplayValue,
          highlight: compareValues(
            isGstMode
              ? bdfData?.parentCompanyId?.gstNumber ||
              bdfData?.brandId?.partyCompany?.gstNumber ||
              bdfData?.gstNumber
              : bdfData?.parentCompanyId?.panNumber ||
              bdfData?.brandId?.partyCompany?.panNumber ||
              bdfData?.panNumber,
            log?.parentCompanyId?.[isGstMode ? "gstNumber" : "panNumber"]
          ),
        },
        {
          value: toUpperCase(bdfData?.brandName || bdfData?.brandId?.brandName),
          highlight: compareValues(
            bdfData?.brandId?.brandName,
            log?.brandId?.brandName
          ),
        },
        {
          value: toUpperCase(bdfData?.campaignName),
          highlight: compareValues(bdfData.campaignName, log?.campaignName),
        },
        {
          value: bdfData.billingPartyName,
          highlight: compareValues(
            bdfData.billingPartyName,
            log?.billingPartyName
          ),
        },
        {
          value: bdfData.billingAddress,
          highlight: compareValues(bdfData.billingAddress, log?.billingAddress),
        },
        {
          value: bdfData.brandSegment,
          highlight: compareValues(bdfData.brandSegment, log?.brandSegment),
        },
        {
          value: bdfData.contactPerson,
          highlight: compareValues(bdfData.contactPerson, log?.contactPerson),
        },
      ],
      bdfValues3: [
        {
          value: bdfData.contactNumber,
          highlight: compareValues(bdfData.contactNumber, log?.contactNumber),
        },
        {
          value: bdfData.emailId,
          highlight: compareValues(bdfData.emailId, log?.emailId),
        },
        {
          value: bdfData.modeOfPayment,
          highlight: compareValues(bdfData.modeOfPayment, log?.modeOfPayment),
        },
        {
          value: bdfData.creditPeriod,
          highlight: compareValues(bdfData.creditPeriod, log?.creditPeriod),
        },
        {
          value: bdfData.campaignDuration,
          highlight: compareValues(
            bdfData.campaignDuration,
            log?.campaignDuration
          ),
        },
        {
          value: formatCellValue(bdfData?.remark),
          highlight: compareValues(bdfData?.remark, log?.remark),
        },
      ],
    };
  };

  const maxLength = Math.max(
    bdfHeaders1.length,
    bdfHeaders2.length,
    bdfHeaders3.length
  );

  worksheet.mergeCells(`E4:N4`);
  const accountHeaderCell = worksheet.getCell("E4");
  worksheet.getRow(accountHeaderCell.row).height = 60;
  accountHeaderCell.value = "Client & Campaign Details";
  accountHeaderCell.font = {
    size: 30,
    bold: true,
    color: { argb: "FFFFFF" },
  };
  accountHeaderCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "000000" },
  };
  accountHeaderCell.alignment = { vertical: "middle", horizontal: "center" };
  // const creditPeriodCell = worksheet.getCell("E8");
  // creditPeriodCell.alignment = { horizontal: "left" };

  const { bdfValues1, bdfValues2, bdfValues3 } = generateHighlightedValues(
    bdfData,
    log
  );

  for (let i = 0; i < maxLength; i++) {
    const row = [];

    if (i < bdfHeaders1.length) {
      const valueObj = bdfValues1[i] || { value: "", highlight: false };

      row.push(bdfHeaders1[i], "", valueObj.value, "");
    } else {
      row.push("", "", "", "");
    }

    if (i < bdfHeaders2.length) {
      const valueObj = bdfValues2[i] || { value: "", highlight: false };
      row.push(bdfHeaders2[i], "", valueObj.value, "", "");
    } else {
      row.push("", "", "", "", "");
    }

    if (i < bdfHeaders3.length) {
      const valueObj = bdfValues3[i] || { value: "", highlight: false };
      row.push(bdfHeaders3[i], "", valueObj.value, "", "");
    } else {
      row.push("", "", "", "", "");
    }

    const addedRow = worksheet.addRow(row);

    addedRow.height = 60;

    addedRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      const isValueColumn =
        colNumber === 3 || colNumber === 7 || colNumber === 12;

      // Determine which array and index the cell belongs to
      let valueObj = { value: "", highlight: false };
      if (colNumber === 3) {
        valueObj = bdfValues1[i] || { value: "", highlight: false };
      } else if (colNumber === 7) {
        valueObj = bdfValues2[i] || { value: "", highlight: false };
      } else if (colNumber === 12) {
        valueObj = bdfValues3[i] || { value: "", highlight: false };
      }

      if (isValueColumn && valueObj.highlight) {
        cell.value = formatCellValue(valueObj.value);

        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFA500" }, // Orange color
        };
      }

      cell.alignment = {
        vertical: "middle",
        horizontal: "left",
        indent: 1,
        wrapText: true,
      };

      cell.font = {
        size: 25,
      };
    });

    // Merge cells for headers and values
    let colNumber = 1;
    while (colNumber < row.length) {
      worksheet.mergeCells(
        `${addedRow.getCell(colNumber).address}:${addedRow.getCell(colNumber + 1).address
        }`
      );
      if (colNumber == 5) {
        worksheet.mergeCells(
          `${addedRow.getCell(colNumber + 2).address}:${addedRow.getCell(colNumber + 4).address
          }`
        );
      } else if (colNumber == 10) {
        worksheet.mergeCells(
          `${addedRow.getCell(colNumber + 2).address}:${addedRow.getCell(colNumber + 4).address
          }`
        );
      } else {
        worksheet.mergeCells(
          `${addedRow.getCell(colNumber + 2).address}:${addedRow.getCell(colNumber + 3).address
          }`
        );
      }

      if (colNumber == 5) {
        colNumber += 5;
      } else {
        colNumber += 4;
      }
    }

    // Set fill and font properties for the header cells
    let numm = 1;
    while (numm < row.length) {
      const headerCell = addedRow.getCell(numm);
      headerCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "EBF2DE" },
      };
      headerCell.font = { bold: true, size: 25 };
      if (numm == 5) {
        numm += 5;
      } else {
        numm += 4;
      }
    }

    // Apply border to each cell
    addedRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  }

  const mediumWidth = 20;
  const largeWidth = ["D"];
  const midLarge = ["G", "H", "I", "J"];
  const specificWidth = ["A"];
  const widthForJK = ["K", "A", "B"];
  const widthForCD = ["C", "F"];
  const widthForEF = ["E"];
  const widthForLM = ["L", "M"];
  const widthForNOPQREtc = [
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];

  widthForNOPQREtc.forEach((letter) => {
    if (!worksheet.getColumn(letter)) {
      worksheet.getColumn(letter).letter = letter;
    }
  });

  worksheet.columns.forEach((column) => {
    if (largeWidth.includes(column.letter)) {
      column.width = 80;
    } else if (midLarge.includes(column.letter)) {
      column.width = 30;
    } else if (specificWidth.includes(column.letter)) {
      column.width = 30;
    } else if (widthForJK.includes(column.letter)) {
      column.width = 28;
    } else if (widthForEF.includes(column.letter)) {
      column.width = 35;
    } else if (widthForNOPQREtc.includes(column.letter)) {
      column.width = 35;
    } else if (widthForLM.includes(column.letter)) {
      column.width = 30;
    } else if (widthForCD.includes(column.letter)) {
      column.width = 50;
    } else {
      column.width = mediumWidth;
    }
  });

  ["G", "H", "I"].forEach((letter) => {
    worksheet.getCell(`${letter}10`).font = {
      size: 16,
    };
  });

  // Add two empty rows
  const firstEmptyRow = worksheet.addRow([""]);
  const secondEmptyRow = worksheet.addRow([""]);

  worksheet.getRow(firstEmptyRow.number).getCell(1).border = {
    left: { style: "thin" },
  };

  worksheet.getRow(firstEmptyRow.number).getCell(worksheet.columnCount).border =
  {
    right: { style: "thin" },
  };

  worksheet.getRow(secondEmptyRow.number).getCell(1).border = {
    left: { style: "thin" },
  };

  worksheet
    .getRow(secondEmptyRow.number)
    .getCell(worksheet.columnCount).border = {
    right: { style: "thin" },
  };

  // Display Cost and Production Details Headers
  const displayCostHeader = [
    "Property Name",
    "CAS Code",
    "Vendor",
    "Execution Location / Particulars",
    "Format / Facility",
    "Media Planner Name",
    "Media Size (W)",
    "Media Size (H)",
    "Start Date",
    "End Date",
    "Amount (In A/C)",
    "Special Rate Per Month",
    "Amount (Payout)",
    "Profit",
  ];

  const headerRow = worksheet.addRow(displayCostHeader);
  headerRow.font = { bold: true };

  headerRow.height = 60;

  headerRow.eachCell({ includeEmpty: true }, (cell, index) => {
    // Alignment with indent and wrapping
    cell.alignment = {
      vertical: "middle",
      horizontal: "left",
      indent: 1,
      wrapText: true,
    };

    // Font settings
    cell.font = { size: 25, bold: true };

    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFF00" }, // Yellow background
    };
  });

  // Adding Display Cost Data
  let displaySum = 0;
  let logDisplaySum = 0;

  const logInventories = log?.inventories || [];
  logInventories.forEach((logInventory) => {
    logDisplaySum += logInventory.specialRate || 0;
  });
  const isLogEmpty = Object.keys(log).length === 0;

  inventories.forEach((inventory, index) => {
    const logInventory = logInventories[index] || {};

    const row = [
      {
        value: inventory.codeNo || inventory?.invId?.CodeNo,
        highlight: false,
      },
      {
        value: inventory?.invId?.CASCode,
        highlight: false,
      },
      {
        value: inventory?.invId?.ownedBy,
        highlight: false,
      },
      {
        value: inventory.location || inventory?.invId?.locations?.name,
        highlight: false,
      },
      {
        value: inventory.mediaVehicle || inventory?.invId?.typeOfMedia?.name,
        highlight: false,
      },
      {
        value: bdfData.mediaPlannerName,
        highlight: false, // Static value, no comparison
      },
      {
        value: inventory.width || inventory?.invId?.width,
        highlight: false,
      },
      {
        value: inventory.height || inventory?.invId?.height,
        highlight: false,
      },
      {
        value: inventory.startDate
          ? moment(inventory.startDate).format("DD-MM-YYYY")
          : "",
        highlight: isLogEmpty
          ? false
          : (inventory.startDate
            ? moment(inventory.startDate).format("DD-MM-YYYY")
            : "") !==
          (logInventory.startDate
            ? moment(logInventory.startDate).format("DD-MM-YYYY")
            : ""),
      },
      {
        value: inventory.endDate
          ? moment(inventory.endDate).format("DD-MM-YYYY")
          : "",
        highlight: isLogEmpty
          ? false
          : (inventory.endDate
            ? moment(inventory.endDate).format("DD-MM-YYYY")
            : "") !==
          (logInventory.endDate
            ? moment(logInventory.endDate).format("DD-MM-YYYY")
            : ""),
      },
      {
        value: inventory?.specialRate,
        highlight: isLogEmpty
          ? false
          : inventory?.specialRate !== logInventory?.specialRate,
      },
      {
        value: inventory?.specialRatePerMonth,
        highlight: isLogEmpty
          ? false
          : inventory?.specialRatePerMonth !==
          logInventory?.specialRatePerMonth,
      },
      {
        // BDF line maintenanceRate (not populated invId.PurchaseRate)
        value:
          inventory?.invId?.isTrading == true
            ? formatIndianNumber(inventory?.maintenanceRate)
            : "",
        highlight: isLogEmpty
          ? false
          : (inventory?.invId?.isTrading == true
            ? formatIndianNumber(inventory?.maintenanceRate)
            : "") !==
          (logInventory?.invId?.isTrading == true
            ? formatIndianNumber(logInventory?.maintenanceRate)
            : ""),
      },
      {
        value:
          inventory?.invId?.CodeNo === "Khushi"
            ? 0
            : inventory?.invId?.isTrading == true
              ? formatIndianNumber(
                  inventory.specialRate - (inventory?.maintenanceRate ?? 0)
                )
              : "",
        highlight: isLogEmpty
          ? false
          : (inventory?.invId?.isTrading == true
              ? formatIndianNumber(
                  inventory.specialRate - (inventory?.maintenanceRate ?? 0)
                )
              : "") !==
            (logInventory?.invId?.isTrading == true
              ? formatIndianNumber(
                  logInventory.specialRate -
                    (logInventory?.maintenanceRate ?? 0)
                )
              : ""),
      },
    ];

    displaySum += inventory.specialRate;

    const addedRow = worksheet.addRow(row.map((cell) => cell.value));
    addedRow.height = 60;

    addedRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      const { value, highlight } = row[colNumber - 1] || {
        highlight: false,
        value: "",
      };

      if (highlight) {
        cell.value = `${value}`;
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFA500" }, // Orange for mismatched data
        };
      }

      cell.alignment = {
        vertical: "middle",
        horizontal: "left",
        indent: 1,
        wrapText: true,
      };
      cell.font = { size: 25 };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // Check if suffixInventories is present and is an array before processing
  if (Array.isArray(suffixInventories) && suffixInventories.length > 0) {
    suffixInventories?.forEach((suffixInventory, index) => {
      const row = [
        { value: "", highlight: false }, // Property Name
        { value: "", highlight: false }, // CAS Code
        { value: suffixInventory?.vendor, highlight: false }, // Agency / Mall / Multiplex Name -> Vendor
        { value: suffixInventory?.suffixInfo, highlight: false }, // Execution Location -> suffixInfo
        { value: "", highlight: false }, // Format / Facility
        { value: "", highlight: false }, // Media Planner Name
        { value: "", highlight: false }, // Media Size (W)
        { value: "", highlight: false }, // Media Size (H)
        {
          value: suffixInventory?.startDate
            ? moment(suffixInventory?.startDate).format("DD-MM-YYYY")
            : "",
          highlight: false,
        }, // Start Date
        {
          value: suffixInventory?.endDate
            ? moment(suffixInventory?.endDate).format("DD-MM-YYYY")
            : "",
          highlight: false,
        }, // End Date
        { value: suffixInventory?.specialRate, highlight: false }, // Amount (In A/C) -> Special Rate
        { value: suffixInventory?.specialRate, highlight: false }, // Special Rate Per Month -> Special Rate
        { value: suffixInventory?.purchaseRate, highlight: false }, // Amount (Payout) -> Purchase Rate
        { value: "", highlight: false }, // Profit
      ];

      displaySum += suffixInventory?.specialRate;

      const addedRow = worksheet.addRow(row.map((cell) => cell.value));
      addedRow.height = 60;

      addedRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "left",
          indent: 1,
          wrapText: true,
        };
        cell.font = { size: 25 };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });
  }

  // Add a row for Subtotal and specialRateTotal
  const subtotalHighlight = !isLogEmpty && displaySum !== logDisplaySum;

  const displayCostSubtotal = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Subtotal",
    "",
    formatIndianNumber(displaySum),
    "",
    "",
    "",
  ];

  // Add the subtotal row and apply font styling
  const subtotalRow = worksheet.addRow(displayCostSubtotal);
  subtotalRow.font = { bold: true };

  // Set row height
  subtotalRow.height = 60;

  // Apply alignment, wrapping, borders, and fill to each cell
  subtotalRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
    // Apply border
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    if (colNumber === 11 && subtotalHighlight) {
      cell.value = `${cell.value}`;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "EBF2DE" },
      };
    } else {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "EBF2DE" }, // Light gray background
      };
    }

    // Align "Subtotal" to the right, others to the left
    cell.alignment = {
      vertical: "middle",
      horizontal: "right",
      indent: 1,
      wrapText: true,
    };

    // Set font size
    cell.font = { size: 25, bold: true };
  });

  // Merge "Subtotal" cells (H and I columns)
  worksheet.mergeCells(`I${subtotalRow.number}:J${subtotalRow.number}`);

  // Add Production Details
  const productionDetailsHeader = [
    "Production Details",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ];

  // Add an empty row before the header

  const emptyRow = worksheet.addRow([""]);
  // This is where you'll track the starting row for production details
  const productionHeaderRow = worksheet.lastRow.number + 1; // Row where header will be added

  worksheet.getRow(emptyRow.number).getCell(1).border = {
    left: { style: "thin" },
  };

  worksheet.getRow(emptyRow.number).getCell(worksheet.columnCount).border = {
    right: { style: "thin" },
  };

  // Add the header row
  const productionDetailsHeaderRow = worksheet.addRow(productionDetailsHeader);
  productionDetailsHeaderRow.font = { bold: true };

  // The production content will start after the header
  const productionStartRow = worksheet.lastRow.number + 1;

  // Set row height
  productionDetailsHeaderRow.height = 60;

  // Apply cell styling and borders
  productionDetailsHeaderRow.eachCell({ includeEmpty: true }, (cell) => {
    // Apply border to the cell
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    // Set background fill color (light gray)
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "EBF2DE" },
    };

    // Set alignment, font size, and wrapping
    cell.alignment = {
      vertical: "middle",
      horizontal: "left",
      indent: 1,
      wrapText: true,
    };
    cell.font = { size: 25, bold: true };
  });

  // Merge cells from A to L
  worksheet.mergeCells(
    `A${productionDetailsHeaderRow.number}:M${productionDetailsHeaderRow.number}`
  );

  // Get the merged cell and adjust alignment
  const mergedCell = worksheet.getCell(`A${productionDetailsHeaderRow.number}`);
  mergedCell.alignment = { horizontal: "center", vertical: "middle" };

  let productionSum = 0;
  const productionRows = [];

  // Helper to add a production row and apply styling
  const addProductionRow = (row, hasProduction) => {
    const addedRow = worksheet.addRow(row.map((cell) => cell.value));
    if (hasProduction) {
      productionRows.push(addedRow.number);
    }
    addedRow.height = 60;
    addedRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      const { value, highlight } = row[colNumber - 1] || { highlight: false };
      if (highlight) {
        cell.value = `${value}`;
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFA500" },
        };
      }
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: "left",
        indent: 1,
        wrapText: true,
      };
      cell.font = { size: 25 };
    });
  };

  inventories.forEach((inventory, index) => {
    const logInventory = logInventories[index] || {};

    const startDate = isSubBDF
      ? bdfData?.bdfDate || ""
      : inventory.startDate
        ? moment(inventory.startDate).format("DD-MM-YYYY")
        : "";
    const logStartDate = isSubBDF
      ? log?.bdfDate || ""
      : logInventory.startDate
        ? moment(logInventory.startDate).format("DD-MM-YYYY")
        : "";

    const innovationRate = inventory.innovationRate || 0;
    const printingMountingCost =
      inventory.mountingCharge + inventory.printingCharge;
    const logPrintingMounting =
      (logInventory.mountingCharge || 0) + (logInventory.printingCharge || 0);
    const logInnovationRate = logInventory.innovationRate || 0;

    const highlightStartDate = !isLogEmpty && startDate !== logStartDate;
    const highlightPrintingMounting =
      !isLogEmpty && printingMountingCost !== logPrintingMounting;
    const highlightInnovation =
      !isLogEmpty && innovationRate !== logInnovationRate;

    productionSum += printingMountingCost + innovationRate;

    // Row 1: Printing & Mounting (if printing or mounting present)
    const hasPrintingMounting =
      inventory.mountingCharge > 0 || inventory.printingCharge > 0;
    let printingMountingTitle = "";
    if (inventory.mountingCharge > 0 && inventory.printingCharge > 0) {
      printingMountingTitle = "Printing & Mounting";
    } else if (inventory.printingCharge > 0) {
      printingMountingTitle = "Printing";
    } else if (inventory.mountingCharge > 0) {
      printingMountingTitle = "Mounting";
    }

    if (hasPrintingMounting) {
      const printingMountingRow = [
        { value: "", highlight: false },
        { value: "", highlight: false },
        { value: printingMountingTitle, highlight: false },
        {
          value: inventory.location || inventory?.invId?.locations?.name,
          highlight: false,
        },
        {
          value: inventory.mediaVehicle || inventory?.invId?.typeOfMedia?.name,
          highlight: false,
        },
        { value: bdfData.mediaPlannerName, highlight: false },
        {
          value: inventory.width || inventory?.invId?.width,
          highlight: false,
        },
        {
          value: inventory.height || inventory?.invId?.height,
          highlight: false,
        },
        { value: startDate, highlight: highlightStartDate },
        { value: "", highlight: false },
        {
          value: bdfData?.packageRate ? "" : printingMountingCost,
          highlight: highlightPrintingMounting,
        },
        { value: "", highlight: false },
        { value: "", highlight: false },
        { value: "", highlight: false },
      ];
      addProductionRow(printingMountingRow, true);
    }

    // Row 2: Innovation (separate row when innovation is present)
    if (innovationRate > 0) {
      const innovationRow = [
        { value: "", highlight: false },
        { value: "", highlight: false },
        { value: "Innovation", highlight: false },
        {
          value: inventory.location || inventory?.invId?.locations?.name,
          highlight: false,
        },
        {
          value: inventory.mediaVehicle || inventory?.invId?.typeOfMedia?.name,
          highlight: false,
        },
        { value: bdfData.mediaPlannerName, highlight: false },
        {
          value: inventory.width || inventory?.invId?.width,
          highlight: false,
        },
        {
          value: inventory.height || inventory?.invId?.height,
          highlight: false,
        },
        { value: startDate, highlight: highlightStartDate },
        { value: "", highlight: false },
        {
          value: bdfData?.packageRate ? "" : innovationRate,
          highlight: highlightInnovation,
        },
        { value: "", highlight: false },
        { value: "", highlight: false },
        { value: "", highlight: false },
      ];
      addProductionRow(innovationRow, true);
    }
  });
  // After the loop, set the production end row if we have production rows
  const productionEndRow =
    productionRows.length > 0
      ? productionRows[productionRows.length - 1]
      : null;

  // Now check if merging is needed
  if (bdfData?.packageRate && productionSum > 0 && productionRows.length > 1) {
    // Merge all production cells in column K
    worksheet.mergeCells(`K${productionStartRow}:K${productionEndRow}`);

    // Set the merged cell's value to the production sum
    const mergedProductionCell = worksheet.getCell(`K${productionStartRow}`);
    mergedProductionCell.value = productionSum;

    // Style the merged cell
    mergedProductionCell.alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };

    mergedProductionCell.font = {
      size: 25,
      bold: true,
    };

    // Add border to the merged cell
    mergedProductionCell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    // // Highlight if needed
    // if (productionSubtotalHighlight) {
    //   mergedProductionCell.fill = {
    //     type: "pattern",
    //     pattern: "solid",
    //     fgColor: { argb: "FFA500" }, // Orange for mismatched data
    //   };
    // }
  }

  const displayCostCell = worksheet.getCell(`A14`);
  displayCostCell.value = "Display Cost (Filled by Sales Person)";

  // Apply formatting to the cell
  displayCostCell.alignment = {
    horizontal: "center",
    vertical: "middle",
    indent: 1,
    wrapText: true,
  };
  displayCostCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "EBF2DE" },
  };
  displayCostCell.border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };
  displayCostCell.font = { size: 25, bold: true };
  worksheet.getRow(displayCostCell.row).height = 60;

  // Merge cells to span the width of columns E and F
  worksheet.mergeCells(`A14:N14`);

  // Update formatting for merged cells
  const mergeCell = worksheet.getCell(`E14`);
  mergeCell.alignment = { horizontal: "center", vertical: "middle" };
  mergeCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "EBF2DE" }, // Yellow background
  };
  mergeCell.border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };

  // Calculate the subtotal for the new section

  const logProductionSum = logInventories.reduce(
    (sum, logInv) =>
      sum +
      (logInv.mountingCharge || 0) +
      (logInv.printingCharge || 0) +
      (logInv.innovationRate || 0),
    0
  );
  const productionSubtotalHighlight =
    !isLogEmpty && productionSum !== logProductionSum;

  // Add the new subtotal row to the worksheet
  const additionalSubtotalRow = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Subtotal",
    "",
    productionSum,
  ];
  const addedSubtotalRow = worksheet.addRow(additionalSubtotalRow);

  // Set the height of the subtotal row
  addedSubtotalRow.height = 60;

  // Apply formatting to the new subtotal row
  const additionalSubtotalRowIndex = worksheet.lastRow.number;
  productionDetailsHeader.forEach((header, index) => {
    const cell = worksheet
      .getRow(additionalSubtotalRowIndex)
      .getCell(index + 1);
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "EBF2DE" }, // Yellow background
    };

    // Align "Subtotal" to the right
    if (cell.value === "Subtotal") {
      cell.alignment = { horizontal: "right" };
      cell.font = { bold: true };
    }
    // Make productionSum bold
    if (index === 10) {
      if (productionSubtotalHighlight) {
        cell.value = `${cell.value}`; // Append (Revised) to mismatched subtotal value
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFA500" }, // Orange background for mismatch
        };
      }
      cell.font = { size: 25, bold: true };
      cell.alignment = { horizontal: "right", vertical: "middle" };
    }

    cell.alignment = {
      vertical: "middle",
      horizontal: "right",
      indent: 1,
      wrapText: true,
    };

    // Set font size for all cells
    cell.font = {
      size: 25,
      bold: true,
    };
  });

  // Merge cells for the new subtotal row
  worksheet.mergeCells(
    `I${additionalSubtotalRowIndex}:J${additionalSubtotalRowIndex}`
  );

  // Calculate the total for (Display + Production)
  const displayProductionTotal = bdfData?.packageRate
    ? bdfData.packageRate + productionSum // Add packageRate and productionSum when packageRate exists
    : displaySum + productionSum; // Otherwise, add displaySum and productionSum

  const displayProductionTotalHighlight =
    productionSubtotalHighlight || subtotalHighlight;

  // Add the (Display + Production) TOTAL row to the worksheet
  const displayProductionTotalRow = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    bdfData?.packageRate ? "Package Rate" : "(Display + Production) TOTAL",
    "",
    formatIndianNumber(displayProductionTotal),
  ];
  const addedTotalRow = worksheet.addRow(displayProductionTotalRow);
  addedTotalRow.height = 60; // Set height for the row

  // Apply formatting to the (Display + Production) TOTAL row
  const displayProductionTotalRowIndex = worksheet.lastRow.number;
  productionDetailsHeader.forEach((header, index) => {
    const cell = worksheet
      .getRow(displayProductionTotalRowIndex)
      .getCell(index + 1);
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "EBF2DE" }, // Yellow background
    };

    cell.alignment = {
      vertical: "middle",
      horizontal: "left",
      indent: 1,
      wrapText: true,
    };

    cell.font = {
      size: 25,
    };

    // Highlight the displayProductionTotal value if needed
    if (index === 10 && displayProductionTotalHighlight) {
      cell.value = `${cell.value}`; // Append (Revised) if highlighted
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFA500" }, // Orange background for mismatched total
      };
      cell.font = { bold: true, size: 25 };
      cell.alignment = { vertical: "middle" };
    }
  });

  // Merge cells for the (Display + Production) TOTAL row
  worksheet.mergeCells(
    `I${displayProductionTotalRowIndex}:J${displayProductionTotalRowIndex}`
  );

  const displayProductionTotalCell = worksheet
    .getRow(worksheet.lastRow.number)
    .getCell(9);

  displayProductionTotalCell.font = { bold: true, size: 25 }; // Make text bold
  displayProductionTotalCell.alignment = {
    horizontal: "right",
    vertical: "middle",
    indent: 1,
    wrapText: true,
  };

  // Get the cell containing the (Display + Production) TOTAL value
  const finalTotal = worksheet.getRow(worksheet.lastRow.number).getCell(11);

  // Apply bold font formatting to the (Display + Production) TOTAL cell
  finalTotal.font = { bold: true, size: 25 };

  finalTotal.alignment = {
    horizontal: "right",
    vertical: "middle",
    indent: 1,
    wrapText: true,
  };

  // Collect changes for the summary section
  const changes = [];

  // Collect changes from bdfValues1, bdfValues2, and bdfValues3
  [bdfValues1, bdfValues2, bdfValues3].forEach((bdfValues, index) => {
    bdfValues.forEach((item, i) => {
      if (item.highlight) {
        const key =
          index === 0
            ? bdfHeaders1[i]
            : index === 1
              ? bdfHeaders2[i]
              : bdfHeaders3[i];
        const oldValue =
          index === 0
            ? log[key] || "N/A"
            : index === 1
              ? log[key] || "N/A"
              : log[key] || "N/A";
        changes.push({
          key,
          oldValue: oldValue || "N/A",
          newValue: item.value || "N/A",
        });
      }
    });
  });

  // Collect changes for inventories
  inventories?.forEach((inventory, index) => {
    const logInventory = log.inventories?.[index] || {};

    const keysToCompare = [
      "startDate",
      "endDate",
      "specialRate",
      "specialRatePerMonth",
      "mountingCharge",
      "printingCharge",
    ];

    let totalChargeProcessed = false;
    let hasChanges = false;

    keysToCompare?.forEach((key) => {
      if (
        key === "mountingCharge" ||
        key === "printingCharge" ||
        key === "innovationRate"
      ) {
        // Check if the total charge has already been processed for this inventory
        if (!totalChargeProcessed) {
          // Sum mountingCharge, printingCharge and innovationRate for comparison
          const oldValue =
            (logInventory["mountingCharge"] || 0) +
            (logInventory["printingCharge"] || 0) +
            (logInventory["innovationRate"] || 0);
          const newValue =
            (inventory["mountingCharge"] || 0) +
            (inventory["printingCharge"] || 0) +
            (inventory["innovationRate"] || 0);

          if (oldValue !== newValue) {
            // changes.push({
            //   key: `Inventory ${index + 1} - Total Charge`,
            //   oldValue: oldValue || "N/A",
            //   newValue: newValue || "N/A",
            // });
            hasChanges = true;
          }
          totalChargeProcessed = true; // Set the flag to true
        }
      } else {
        const oldValue = logInventory[key] || "N/A";
        const newValue = inventory[key] || "N/A";

        if (oldValue !== newValue) {
          // changes.push({
          //   key: `Inventory ${index + 1} - ${key}`,
          //   oldValue: oldValue || "N/A",
          //   newValue: newValue || "N/A",
          // });
          hasChanges = true;
        }
      }
    });
    if (hasChanges) {
      changes.push({
        key: inventory.invId?.locations?.name || `Inventory ${index + 1}`,
      });
    }
  });

  // if (changes?.length > 0 && Object.keys(log).length > 0) {
  //   // Add two blank rows before the summary section
  //   // worksheet.addRow([""]); // First empty row
  //   // worksheet.addRow([""]); // Second empty row

  //   // // Add Summary Title
  //   // const summaryTitle = worksheet.addRow(["Summary of Revised Values"]);
  //   // summaryTitle.font = { bold: true, size: 25 };
  //   // summaryTitle.alignment = { vertical: "middle", horizontal: "center" };

  //   // // Merge title row across three columns
  //   // worksheet.mergeCells(`A${summaryTitle.number}:C${summaryTitle.number}`);

  //   // // Collect all revised values (newValues), formatting dates if necessary
  //   // const revisedValues = changes
  //   //   .map((change) => {
  //   //     // Check if the value is a date (ISO string format) and format it
  //   //     if (
  //   //       ["startDate", "endDate"].some((key) =>
  //   //         change.key.toLowerCase().includes(key.toLowerCase())
  //   //       )
  //   //     ) {
  //   //       // Format the date using moment
  //   //       return moment(change.newValue).isValid()
  //   //         ? moment(change.newValue).format("DD-MM-YYYY")
  //   //         : change.newValue;
  //   //     }
  //   //     // Return the value as-is if it's not a date
  //   //     return change.newValue;
  //   //   })
  //   //   .join(", ");

  //   // // Add a single row to display all the revised values
  //   // const revisedValuesRow = worksheet.addRow([revisedValues]);
  //   // revisedValuesRow.height = 40; // Adjust row height

  //   // // Merge the row across all columns (adjust as per your requirement)
  //   // worksheet.mergeCells(
  //   //   `A${revisedValuesRow.number}:N${revisedValuesRow.number}`
  //   // );

  //   // revisedValuesRow.eachCell((cell) => {
  //   //   cell.font = { size: 20 }; // Set font size for readability
  //   //   cell.alignment = {
  //   //     vertical: "middle",
  //   //     horizontal: "left",
  //   //     wrapText: true, // Wrap text for long content
  //   //   };
  //   // });

  //   const revisedKeys = changes.map((change) => change.key).join(", ");

  //   // ✅ Set the keys in merged cell (L10 to L12)
  //   worksheet.getCell("L10").value = revisedKeys + " has been changed.";

  //   worksheet.getCell("L10").alignment = {
  //     vertical: "middle",
  //     horizontal: "left",
  //     wrapText: true, // Ensures text wraps if long
  //   };
  // }

  try {
    worksheet.unMergeCells("L10:N12");
  } catch (error) {
    console.warn("Cells L10:N12 were not merged previously, skipping unmerge.");
  }

  worksheet.mergeCells("L10:N12");

  // ✅ Ensure the font size in L10:N12 is set to 12

  worksheet.getColumn(11).width = 40;

  worksheet.views = [{ state: "normal", zoomScale: 45 }];
  worksheet.columns.forEach((column) => {
    column.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = { name: "Calibri", size: 25 };
    });
  });

  ["L10", "L11", "L12", "M10", "M11", "M12", "N10", "N11", "N12"].forEach(
    (cell) => {
      worksheet.getCell(cell).font = { name: "Calibri", size: 18 };
    }
  );

  worksheet.pageSetup = {
    orientation: "landscape",
    fitToPage: true,
    fitToWidth: 1,
    fitToHeight: 1,
  };

  // Save the workbook
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  if (downloadBDF === false) {
    const filename = `${bdfData?.brandName || bdfData?.brandId?.brandName
      }_${Date.now()}.xlsx`;
    const mime =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const requestBody = { fileName: filename, mime: mime };

    const response = await fetch(`${apiBaseUrl}/chats/uploadPolicy`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: `Token ${window.localStorage.getItem("token")}`,
      },
      body: JSON.stringify(requestBody),
    });

    const result = await response.json();

    if (result?.data?.url && result?.data?.fields) {
      const formData = new FormData();

      // Set Content-Type first to ensure it matches S3 policy requirements
      const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

      for (const [key, value] of Object.entries(result.data.fields)) {
        // Override Content-Type if present to ensure exact match
        if (key.toLowerCase() === "content-type") {
          formData.set(key, contentType);
        } else {
          formData.set(key, value);
        }
      }

      // Ensure Content-Type is set even if not in fields
      if (!formData.has("Content-Type") && !formData.has("content-type")) {
        formData.set("Content-Type", contentType);
      }

      formData.append("file", blob, filename);

      const uploadResponse = await fetch(result.data.url, {
        method: "POST",
        body: formData,
      });

      if (uploadResponse.ok) {
        const finalUrl = convertS3ToCloudFront(
          `${result.data.url}/${result.filePath}`,
        );

        return finalUrl;
      } else {
        throw new Error("Excel upload failed");
      }
    } else {
      throw new Error("Missing required data in upload response");
    }
  } else {
    saveAs(
      blob,
      `${bdfData?.brandName || bdfData?.brandId?.brandName}_BDFData.xlsx`
    );
  }
}

export default createBDFExcelChanges;
